export const page = (state = "", action) => {
  if (action.type === "NAVIGATE_TO") {
    return action.target;
  }

  return state;
};
